module.exports = __webpack_public_path__ + "assets/443786b21c138f1e1cce86cd1880a1ca.png";